import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function RetardStructureAtelierDeProduction({
  variablesData,
}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Réf : CT/BU S225</p>
      <p>
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        En raison de retards dans la livraison des matériaux nécessaires au
        montage de la structure de l'atelier de production, nous estimons que
        l'atelier ne pourra être terminé dans le délai prévu.
      </p>
      <p>
        La date de livraison de l'atelier à votre entreprise devra être reportée
        du{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.livraison_atelier_production_date_prevue) || 0,
        )}{" "}
        au{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.livraison_atelier_production_date_avec_retard) ||
            0,
        )}
        . Cependant, on m'avise que ce délai peut être réduit de 10 jours
        ouvrables si on ajoute deux manœuvres à l'équipe déjà sur place.
      </p>
      <p>
        Ceci, bien sûr, occasionnera une augmentation d'environ 2640 Euros dans
        le coût de construction. Comme notre contrat ne prévoit pas ce genre de
        supplément, j'attends votre décision sur la question.
      </p>
      <p>Vous trouverez ci-joint la facture des travaux déjà effectués.</p>
      <p>
        Veuillez agréer, Monsieur, l'expression de mes sentiments respectueux.
      </p>
      <MailSignature
        emetteurLogo={RetardStructureAtelierDeProduction.metadata.emetteurLogo}
        emetteur={RetardStructureAtelierDeProduction.metadata.emetteur}
        emetteurPoste={
          RetardStructureAtelierDeProduction.metadata.emetteurPoste
        }
        emetteurEntreprise={
          RetardStructureAtelierDeProduction.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

RetardStructureAtelierDeProduction.metadata = {
  titre: "Retard structure atelier de production",
  cleMail: "retard_structure_atelier_de_production",
  messageTransfert: false,
  emetteur: "Roger COEUR",
  emetteurPoste: "Gérant",
  emetteurEntreprise: "LECCO Construction",
  emetteurLogo: "/logos/lecco.png",
  dateRelative: -2,
  piecesJointes: ["facture-lecco-construction"],
} as MailMetadata;

export default RetardStructureAtelierDeProduction;
